window.addEventListener('load', () => {
    document.addEventListener('input', filterResultsHandler);

    document.addEventListener('click', (e) => {
        const target = e.target;
        const select = target.closest('.js-select');

        if (!select) {
            closeActiveSelect();
            return;
        }

        if (target.closest('.js-select-top')) {
            const activeSelect = document.querySelector('.js-select.active');
            const isEqualNode = activeSelect && activeSelect.isEqualNode(select);

            if (!isEqualNode) {
                closeActiveSelect();
            }
            select.classList.remove('active--top');
            select.classList.toggle('active');

            if (checkEmptySpaceBelow(select) <= 0) select.classList.add('active--top');

            return;
        }

        const selectItem = target.closest('.js-select-item');
        if (selectItem) {
            selectOption(select, selectItem);
        }
    });

    function checkEmptySpaceBelow(selectElement) {
        const selectDownElement = selectElement.querySelector('.js-select-down');
        return document.documentElement.clientHeight - selectDownElement.getBoundingClientRect().bottom - 50;
    }

    function selectOption(select, option) {
        const selectCaption = select.querySelector('.js-select-caption');
        const selectHiddenInput = select.querySelector('.js-select-output');
        const value = option.textContent;

        selectCaption.textContent = value;
        selectHiddenInput.value = option.dataset.optionValue;
        const inputEvent = new Event('input', { bubbles: true });
        selectHiddenInput.dispatchEvent(inputEvent);

        select.classList.remove('active--top');
        select.classList.remove('active');
        selectCaption.classList.remove('hide');
        select.querySelector('.js-select-caption-placeholder').classList.add('hide');

        checkActiveOption(select);
        option.classList.add('active');
    }

    function checkActiveOption(select) {
        const activeOption = select.querySelector('.js-select-item.active');

        if (activeOption) {
            activeOption.classList.remove('active');
        }
    }

    function closeActiveSelect() {
        const activeSelect = document.querySelector('.js-select.active');

        if (activeSelect) {
            activeSelect.classList.remove('active');
            const selectSearch = activeSelect.querySelector('.js-select-search');
            if (selectSearch) {
                resetResults(selectSearch);
            }
        }
    }

    function resetResults(inputSearchElement) {
        inputSearchElement.value = '';
        filterSelectOptions(inputSearchElement.closest('.js-select'), '');
    }

    function filterResultsHandler(e) {
        const target = e.target.closest('.js-select-search');
        if (target) {
            filterSelectOptions(target.closest('.js-select'), target.value);
        }
    }

    function filterSelectOptions(select, queryString) {
        queryString = queryString.toLowerCase().trim();
        const selectOptions = select.querySelectorAll('.js-select-item');
        const selectNoOptions = select.querySelector('.js-select-item-no-options');

        selectOptions.forEach((option) => {
            const optionText = option.textContent.toLowerCase().trim();
            if (optionText.includes(queryString)) {
                option.classList.remove('hide');
            } else {
                option.classList.add('hide');
            }
        });
        const hasResults = selectOptions.length === select.querySelectorAll('.js-select-item.hide').length;
        selectNoOptions.classList.toggle('hide', !hasResults);
    }
});
